import type { ReactNode } from "react";
import type { Tone } from "../../lib/stream-status";
import { cx } from "./cx";

const TONE: Record<Tone, string> = { ok: "bg-ok", info: "bg-info", warn: "bg-warn", bad: "bg-bad", idle: "bg-card" };

/** A boxed message. Errors are announced right away (role=alert); the rest politely (role=status). */
export function Banner({ tone = "info", children, action, className }: { tone?: Tone; children: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div role={tone === "bad" ? "alert" : "status"} className={cx("flex flex-wrap items-center justify-between gap-3 rounded-xl border-2 border-ink px-4 py-3 shadow-hard-sm", TONE[tone], className)}>
      <div className="min-w-0 flex-1">{children}</div>
      {action}
    </div>
  );
}

/** Inline form error; renders nothing without a message. */
export function FormError({ message }: { message: string | null | undefined }) {
  if (!message) return null;
  return <Banner tone="bad">{message}</Banner>;
}
